<template>
    <el-dialog
        :title="(isForm ? (modelId ? '编辑' : '添加品牌') : '查看') + dialogTitle"
        :model-value="modelValue"
        width="640px"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : {}" label-width="120px" style="max-width: 560px">
            <el-form-item label="品牌名称" prop="name">
                <el-input v-if="isForm" v-model="formData.name" placeholder="请输入品牌名称"></el-input>
                <span v-else>{{ formData.name }}</span>
            </el-form-item>
            <el-form-item label="品牌编码" prop="code">
                <el-input v-if="isForm" v-model="formData.code" placeholder="请输入品牌编码"></el-input>
                <span v-else>{{ formData.code }}</span>
            </el-form-item>
            <el-form-item label="厂家" prop="manufacturer">
                <el-input v-if="isForm" v-model="formData.manufacturer" placeholder="请输入厂家"></el-input>
                <span v-else>{{ formData.manufacturer ? formData.manufacturer : '无' }}</span>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
                <el-input v-if="isForm" v-model="formData.phone" placeholder="请输入联系电话"></el-input>
                <span v-else>{{ formData.phone ? formData.phone : '无' }}</span>
            </el-form-item>
            <el-form-item label="显示排序" prop="list_order">
                <el-input-number
                    v-if="isForm"
                    v-model="formData.list_order"
                    class="mx-4"
                    :min="0"
                    :max="999999"
                    controls-position="right"
                />
                <span v-else>{{ formData.list_order }}</span>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-if="isForm" v-model="formData.remark" placeholder="请输入备注" type="textarea"></el-input>
                <div v-else>
                    <span v-if="formData.remark">{{ formData.remark ? formData.remark : '无' }}</span>
                    <span v-else>无</span>
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { addBrandModel, getBrandDetail, putBrandModel } from '@/api/deviceBrand/deviceBrand'
import { ElMessage } from 'element-plus'
import { validatePhone } from '@/utils/rules.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    modelId: {
        type: String,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])
// 表单源
const formData = ref({
    id: '',
    name: '',
    code: '',
    manufacturer: '',
    phone: '',
    remark: '',
    list_order: 1,
    status: 1,
    visible: 1
})
// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '品牌为必填项'
        }
    ],
    phone: [
        {
            required: false,
            trigger: 'blur',
            validator: validatePhone
        }
    ],
    code: [
        {
            required: true,
            message: '品牌编码为必填项',
            trigger: 'blur'
        }
    ]
    // manufacturer: [
    //     {
    //         required: false,
    //         trigger: 'blur',
    //         message: '请输入厂家'
    //     }
    // ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const closed = () => {
    dialogTitle.value = ''
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
    formData.value.remark = ''
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    if (props.modelId !== '') {
        await doPutBrandModel()
    } else {
        await doAddBrandModel()
    }
}

// 修改
const doPutBrandModel = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await putBrandModel({ ...formData.value })
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

// 添加
const doAddBrandModel = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await addBrandModel({ ...formData.value })
            // 模块添加成功
            emits('updateForm')
            ElMessage.success('添加成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

// 获取品牌详情
const doGetEquipModelDetail = async () => {
    const { id, name, code, type, remark, list_order, status, visible, manufacturer, phone } = await getBrandDetail(props.modelId)
    formData.value = {
        id,
        name,
        code,
        type,
        remark,
        list_order,
        status,
        visible,
        manufacturer,
        phone
    }

    dialogTitle.value = name
}

// 只有modelId有的时候，才会去请求数据
watch(
    () => props.modelId,
    (newVal) => {
        if (newVal) {
            doGetEquipModelDetail()
        } else {
            // 置空
            formData.value = {
                id: '',
                name: '',
                code: '',
                type: '',
                manufacturer: '',
                list_order: 1,
                albums: [],
                manual: '',
                remark: ''
            }
            dialogTitle.value = ''
        }
    }
)
</script>

<style lang="scss" scoped>
.albums-lists {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .img-item {
        width: 100px;
        height: 100px;
        background-color: #999;
        border-radius: 5px;
        margin-right: 10px;
    }
}

.albums-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100px;
        height: 100px;

        .avatar-uploader-icon {
            margin-top: 36px;
        }
    }

    :deep(.el-upload-list__item-preview),
    :deep(.el-icon--zoom-in) {
        display: none;
    }
}

.files-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100%;
        height: auto;
    }
}
</style>
